import { IStackProps } from "@fluentui/react";

export const columnHeaderCardProps: Partial<IStackProps> = {
  tokens: { childrenGap: 10 },
  styles: { root: { width: 300 } },
};

export const CustomCardStyle = {
  layout: {
    '& > div': {
      overflowX: 'auto',
    },
  },
};